import { Injectable } from '@angular/core'
import { HttpService } from '../http.service'
import { ADMIN_API_ENDPOINTS } from '../../common/api-endpoints'
import { 
  FloorDto, 
  CreateFloorDto, 
  UpdateFloorDto, 
  FindFloorDto 
} from '../../dto/governance-admin/floor.dto'

@Injectable({
  providedIn: 'root'
})
export class FloorApiService {
  constructor(private readonly httpService: HttpService) {}

  public async getFloors(params: FindFloorDto = {}): Promise<{ rows: FloorDto[], count: number }> {
    const queryParams: any = {}
    
    if (params.limit) queryParams.limit = params.limit.toString()
    if (params.offset) queryParams.offset = params.offset.toString()
    if (params.mallId) queryParams.mallId = params.mallId
    if (params.enabled) queryParams.enabled = params.enabled
    if (params.searchText) queryParams.searchText = params.searchText

    return await this.httpService.get<{ rows: FloorDto[], count: number }>(ADMIN_API_ENDPOINTS.FLOORS, queryParams)
  }

  public async getFloorById(id: string): Promise<FloorDto> {
    return await this.httpService.get<FloorDto>(`${ADMIN_API_ENDPOINTS.FLOORS}/${id}`)
  }

  public async createFloor(data: CreateFloorDto): Promise<FloorDto> {
    return await this.httpService.post<FloorDto>(ADMIN_API_ENDPOINTS.FLOORS, data)
  }

  public async updateFloor(id: string, data: UpdateFloorDto): Promise<FloorDto> {
    return await this.httpService.put<FloorDto>(`${ADMIN_API_ENDPOINTS.FLOORS}/${id}`, data)
  }

  public async deleteFloor(id: string): Promise<boolean> {
    await this.httpService.delete(`${ADMIN_API_ENDPOINTS.FLOORS}/${id}`)
    return true
  }

  public async toggleFloorStatus(id: string, enabled: boolean): Promise<FloorDto> {
    return await this.httpService.patch<FloorDto>(`${ADMIN_API_ENDPOINTS.FLOORS}/${id}`, { enabled })
  }
} 